module.exports = "<!DOCTYPE html>\n<html>\n<head>\n    <title>Subschema Demo</title>\n    <link rel=\"stylesheet\" href=\"https://highlightjs.org/static/demo/styles/github.css\">\n    <link rel=\"stylesheet\" href=\"https://maxcdn.bootstrapcdn.com/bootstrap/3.3.4/css/bootstrap.min.css\">\n    <link rel=\"stylesheet\" href=\"https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.0.0/codemirror.min.css\"/>\n    <link rel=\"stylesheet\" href=\"https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.0.0/theme/monokai.min.css\"/>\n</head>\n<body>\n<div id=\"content\"></div>\n<script  charset=\"utf-8\" src=\"app.js\"></script>\n</body>\n</html>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./public/index.html
 ** module id = 578
 ** module chunks = 0
 **/